<template>
  <div class="mt-6 flex flex-col lg:flex-row" >
    <div class="flex-grow space-y-6">
      <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
        <slot />
      </div>
    </div>
  </div>
</template>
